import { connect } from 'react-redux';
import { confirmYes, confirmNo } from '../../../Modals/redux/actionCreators';
export const mapStateToProps = ()=>({});
export const mapDispatchToProps = (dispatch, props)=>({
        onConfirm: ()=>{
            props.onConfirm && props.onConfirm();
            dispatch(confirmYes());
        },
        onCancel: ()=>{
            props.onCancel && props.onCancel();
            dispatch(confirmNo());
        }
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=GlobalConfirmationModal.container.js.map